import * as React from "react";
import "./loader.css";
interface IMatchesCardLoaderProps {}

export const MatchesCardLoader: React.SFC<IMatchesCardLoaderProps> = (
  props
) => {
  return (
    <div
      className="animated-background border info-card white-background cardloader"
      style={{ padding: 0 }}
    >
      <svg width="100%" height="100%" id="MatchCardLoader">
        <defs>
          <mask id="MatchesCardmask">
            <rect width="100%" height="100%" fill="white" />
            <svg
              version="1.0"
              xmlns="http://www.w3.org/2000/svg"
              width="476px"
              height="240px"
              viewBox="0 0 4760 2000"
              preserveAspectRatio="xMidYMid meet"
            >
              <g id="layer101" fill="#2abcca" stroke="none">
                <path d="M0 1000 l0 -1000 2380 0 2380 0 0 1000 0 1000 -2380 0 -2380 0 0 -1000z" />
              </g>
              <g id="layer102" fill="#ffffff" stroke="none">
                <path d="M0 1000 l0 -1000 2380 0 2380 0 0 1000 0 1000 -2380 0 -2380 0 0 -1000z m725 886 c79 -36 156 -112 191 -190 24 -52 28 -74 29 -151 0 -78 -4 -98 -28 -150 -37 -79 -114 -156 -191 -192 -53 -24 -73 -28 -151 -28 -80 0 -97 3 -155 31 -82 39 -144 101 -184 184 -28 58 -31 75 -31 155 0 80 4 97 31 155 69 144 199 223 354 217 56 -3 91 -10 135 -31z m3920 -171 l0 -160 -595 0 -595 0 -3 150 c-1 82 0 155 2 162 4 11 119 13 598 11 l593 -3 0 -160z m-2207 -392 l212 -6 0 -65 0 -65 -212 6 c-116 4 -244 7 -285 7 l-73 0 0 65 0 65 73 0 c41 0 169 -3 285 -7z m-408 -68 l0 -65 -345 0 -345 0 0 65 0 65 345 0 345 0 0 -65z m-1390 -250 l0 -115 -65 0 -65 0 0 115 0 115 65 0 65 0 0 -115z m1380 50 l0 -65 -340 0 -340 0 0 65 0 65 340 0 340 0 0 -65z m1160 0 l0 -65 -550 0 -550 0 0 65 0 65 550 0 550 0 0 -65z m-1410 -210 l0 -65 -215 0 -215 0 0 65 0 65 215 0 215 0 0 -65z m1220 0 l0 -65 -575 0 -575 0 0 65 0 65 575 0 575 0 0 -65z m-2265 -39 c79 -36 156 -112 191 -190 24 -52 28 -74 29 -151 0 -78 -4 -98 -28 -150 -37 -79 -114 -156 -191 -192 -53 -24 -73 -28 -151 -28 -80 0 -97 3 -155 31 -82 39 -144 101 -184 184 -28 58 -31 75 -31 155 0 80 4 97 31 155 69 144 199 223 354 217 56 -3 91 -10 135 -31z m1515 -151 l0 -65 -450 0 -450 0 0 65 0 65 450 0 450 0 0 -65z m1400 0 l0 -65 -670 0 -670 0 0 65 0 65 670 0 670 0 0 -65z m-1030 -385 l0 -120 -635 0 -635 0 0 120 0 120 635 0 635 0 0 -120z" />
              </g>
            </svg>
          </mask>
        </defs>

        <rect
          id="back"
          width="100%"
          height="100%"
          fill="white"
          mask="url(#MatchesCardmask)"
        />
      </svg>
    </div>
  );
};
